import React from 'react';

import { RadioGroupOption } from '@gogame/components';
import { FormField } from '@gogame/form';

import {
  LOWEST_COST_WITH_BID_CAP,
  LOWEST_COST_WITH_MIN_ROAS,
  LOWEST_COST_WITHOUT_CAP,
  TARGET_COST,
} from '../../constants';

const BidingStrategyField = ({ name }) => {
  return (
    <FormField.RadioGroup name={name} title={'Strategy'} radioVertical={true}>
      <RadioGroupOption
        label={'Lowest cost with min ROAS'}
        value={LOWEST_COST_WITH_MIN_ROAS}
      />
      <RadioGroupOption
        label={'Lowest cost without cap'}
        value={LOWEST_COST_WITHOUT_CAP}
      />
      <RadioGroupOption
        label={'Lowest cost with cap'}
        value={LOWEST_COST_WITH_BID_CAP}
      />
      <RadioGroupOption label={'Target cost'} value={TARGET_COST} />
    </FormField.RadioGroup>
  );
};

export default BidingStrategyField;
